import type { SceneSkin } from './pip-skins'
import type { AdventureMotionOptions } from './adventure-motion'

const gesture = (middle: string): Keyframe[] => [
  { transform: 'none' }, { transform: middle, offset: .45 }, { transform: 'none' },
]

/** Animate physical decorations, leaving every numeric readout stationary. */
export const sceneMotion: Record<SceneSkin, AdventureMotionOptions> = {
  'stream-kerning': {
    rotateAccent: false,
    effects: {
      rise: [{ selector: '.kerning-arrow-feedback', frames: gesture('translateY(-.25rem) rotate(-12deg)') }],
      fall: [{ selector: '.kerning-arrow-feedback', frames: gesture('translateY(.1875rem) rotate(12deg)') }],
      'level-up': [
        { selector: '.kerning-station', frames: gesture('scale(.92) rotate(-4deg)') },
        { selector: '.kerning-speed-lines', frames: [{ transform: 'translateX(-.75rem) scaleX(.2)' }, { transform: 'none', offset: .45 }, { transform: 'translateX(.5rem) scaleX(.6)' }] },
      ],
    },
  },
  'stream-aqua': {
    rotateAccent: false,
    particles: 'bubbles',
    effects: {
      'level-up': [{ selector: '.aqua-window', frames: [{ borderColor: '#739e9d' }, { borderColor: '#efb39a', offset: .45 }, { borderColor: '#739e9d' }] }],
    },
  },
}
